import { render } from "./ArticlesAndMore.vue?vue&type=template&id=c981caa4&scoped=true"
import script from "./ArticlesAndMore.vue?vue&type=script&lang=js"
export * from "./ArticlesAndMore.vue?vue&type=script&lang=js"

import "./ArticlesAndMore.vue?vue&type=style&index=0&id=c981caa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c981caa4"]])

export default __exports__